const ACTIVIDADES = [
    { value: "no-aplica", label: "No Aplica" },
    { value: "inmobiliaria", label: "Inmobiliaria" },
    { value: "fe-publica", label: "Fe Pública" },
    { value: "mutuo", label: "Mutuo/Préstamo/Crédito" },
];

export default ACTIVIDADES;
